"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSchema = void 0;
const zod_1 = require("zod");
const object_1 = require("../../utils/object");
const schemaUtils_1 = require("./schemaUtils");
const translation_1 = require("./translation");
const schemaBuilder = {
    ['boolean']: (formatMessage, config) => {
        let result = zod_1.z.boolean({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
    string: (formatMessage, config) => {
        const { email, url, minLength } = config !== null && config !== void 0 ? config : {};
        let result = zod_1.z.string({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = email ? result.email() : result;
        result = url ? result.url() : result;
        result = minLength !== undefined ? result.min(minLength) : result;
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
    date: (formatMessage, config) => {
        const { dateRestrictions } = config !== null && config !== void 0 ? config : {};
        let result = zod_1.z.string({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = (0, schemaUtils_1.dateSchema)(result, formatMessage, dateRestrictions);
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
    number: (formatMessage, config) => {
        const { roundedMoney, integer, positive, withoutZero, maxNumber } = config !== null && config !== void 0 ? config : {};
        let numberResult = zod_1.z.number({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        numberResult = maxNumber !== undefined ? numberResult.max(maxNumber) : numberResult;
        numberResult = roundedMoney ? numberResult.multipleOf(0.05) : numberResult;
        numberResult = integer ? numberResult.int() : numberResult;
        const getPositive = () => {
            if (positive && withoutZero)
                return numberResult.positive();
            if (positive)
                return numberResult.nonnegative();
            return numberResult;
        };
        let result = getPositive();
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
    object: (formatMessage, config) => {
        const { shape } = config !== null && config !== void 0 ? config : {};
        const objectSchema = shape
            ? (0, object_1.mapObject)(shape, ([_, value]) => (0, exports.createSchema)(formatMessage, value))
            : {};
        let result = zod_1.z.object(objectSchema, {
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
    array: (formatMessage, config) => {
        const { shape } = config !== null && config !== void 0 ? config : {};
        const itemSchema = (0, exports.createSchema)(formatMessage, shape === null || shape === void 0 ? void 0 : shape.item);
        let result = zod_1.z.array(itemSchema, {
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
    any: (formatMessage, config) => {
        let result = zod_1.z.any({
            errorMap: (issue, ctx) => ({ message: (0, translation_1.translateError)(formatMessage, issue, ctx) }),
        });
        result = (!config || config.optional) ? (0, schemaUtils_1.optionalSchema)(result) : result;
        return result;
    },
};
const createSchema = (formatMessage, config) => {
    const availableTypes = ['boolean', 'number', 'string', 'date', 'array', 'object'];
    const hasAvailableType = (type) => (!!availableTypes.find(x => x === type));
    const configType = config === null || config === void 0 ? void 0 : config.type;
    if (hasAvailableType(configType)) {
        return schemaBuilder[configType](formatMessage, config);
    }
    return schemaBuilder.any(formatMessage, config);
};
exports.createSchema = createSchema;
//# sourceMappingURL=schema.js.map